let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2n8AT")).then(() => parcelRequire('cv3PF'));